import { RouterModule } from '@angular/router';
import { SelectivePreloadingStrategy } from './routing/selective-preloading-strategy';
import { environment } from "../environments/environment";

interface AppConfiguration
{
    Urls: UrlsConfiguration,
    RoutingConfig: RoutingConfiguration,
    AuthConfig: AuthConfiguration
}

interface UrlsConfiguration
{
    WebAPI: string
}

interface RoutingConfiguration
{
    useHash: boolean,
    enableTracing: boolean,
    preloadingStrategy: any
}

interface AuthConfiguration
{
    clientID: string,
    domain: string,
    callbackURL: string
}

export const AppConfig: AppConfiguration = {
    Urls: {
        WebAPI: environment.WebAPIUrl
    },
    RoutingConfig: {
        useHash: true,
        enableTracing: !environment.production,
        preloadingStrategy: SelectivePreloadingStrategy
    },
    AuthConfig: {
        clientID: '{CLIENT_ID}',
        domain: '{DOMAIN}',
        // You may need to change this!
        callbackURL: '/RestService'
    }
};


// WEBPACK FOOTER //
// ./src/app/app.config.ts